module.exports = __webpack_public_path__ + "static/img/upload.9be9c330.png";